import Auth from "./Auth.vue";
import Hero from "./Hero.vue";
import Services from "./Services.vue";
import Accreditation from "./Accreditation.vue";
import NoNeed from "./NoNeed.vue";
import ForWhom from "./ForWhom.vue";
import Slider from "./Slider.vue";
import About from "./About.vue";
import Geography from "./Geography.vue";
import Cta from "./Cta.vue";

// Соответствие App\Landing\Enums\LandingBlockType -> Vue-компонент.
export const blockComponents = {
    auth: Auth,
    hero: Hero,
    services: Services,
    accreditation: Accreditation,
    no_need: NoNeed,
    for_whom: ForWhom,
    slider: Slider,
    about: About,
    geography: Geography,
    cta: Cta,
};

export function resolveBlock(type) {
    return blockComponents[type] || null;
}
